import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { Link as LinkTo } from 'react-router';
import { BackButton } from "../../../../../common/components/back_button"
import { CadastroReajusteModal } from "./components/cadastro_reajuste"
import DefaultFormInput from "../../../../../common/components/default_form_input"
import { FormSwitchInput } from "../../../../../common/components/masked_inputs/react_forms/form_switch_input"
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { Reajuste } from "../../../domain/models/reajuste"
import FormContainer from "../../../../../common/components/form_container"
import { GenerateReajusteColumns } from "./columns"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import BottomBar from "../../../../../common/components/bottom_bar"
import { useFinanceiroReajusteCadastroViewModel } from "../../viewModels/financeiro_reajuste_cadastro_view_model"
import { LogTipoTabela } from "../../../../../common/utils/log_tabela_tipo"


export const FinanceiroReajusteCadastro = () => {

    const viewModel = useFinanceiroReajusteCadastroViewModel();

    const columnsDef = useMemo(() => {
        return GenerateReajusteColumns({
            onActionEditar: viewModel.handleEditReajusteOpenState,
            onActionDeletar: viewModel.handleReajusteDeleteOpenState,

        });
    }, [
        viewModel.handleEditReajusteOpenState,
        viewModel.handleReajusteDeleteOpenState
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <BackButton
                                onClick={() => viewModel.handlePageBack()} />

                            {/* <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewindiceReajuste()}>
                                    Novo Indice
                                </PrimaryButton> 
                            </div> */}

                        </div>
                    }
                />
            </PageTopBar >

            <form className="pb-8" onSubmit={viewModel.handleIndiceReajusteCadastroSubmit}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Home
                        </Link>
                        <Link underline="hover" color="inherit">
                            <LinkTo to="/FinanceiroReajustes_lista" >Indice Reajustes Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Indice Reajuste Cadastro
                        </Typography>
                    </Breadcrumbs>

                    <div className="div flex justify-start items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Índice de Reajuste
                            </h1>
                            <RefreshButton onClick={viewModel.handleReload} />
                        </div>
                    </div>

                    {
                        viewModel.errorMessage !== undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                                    <FormContainer title="Informações" arrangement="fullRow" border={false}>
                                        <div className="flex flex-col items-start w-full gap-4">
                                            <div className=" w-[25%] flex items-start justify-between">
                                                <label className="font-medium text-gray-700">Status:</label>
                                                <FormSwitchInput
                                                    activeLabel="Ativo"
                                                    inactiveLabel="Inativo"
                                                    name="status"
                                                    readOnly={viewModel.saving}
                                                    reactHookForm={viewModel.hookFormIndice}
                                                />
                                            </div>

                                            <DefaultFormInput
                                                name='descricao'
                                                label='Descrição Indice'
                                                required={true}
                                                reactHookForm={viewModel.hookFormIndice} />

                                            <div className="w-[50%]">
                                                <FormDatePickerInput
                                                    name="dataCadastro"
                                                    readOnly={true}
                                                    required={true}
                                                    label="Data Cadastro"
                                                    reactHookForm={viewModel.hookFormIndice}
                                                />
                                            </div>

                                        </div>
                                    </FormContainer>

                                    <Stack spacing={0}>
                                        <div className="w-full flex flex-row justify-between items-stretch">
                                            <div className="flex flex-col justify-between flex-1">
                                                <TablePagination
                                                    component="div"
                                                    count={viewModel.pagination.totalItems}
                                                    page={viewModel.pagination.page - 1}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                                    rowsPerPage={viewModel.pagination.rowsPerPage}
                                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                            </div>
                                        </div>

                                        <StyledDataGrid
                                            tableName="reajuste_cadastro_lista"
                                            disableColumnMenu={false}
                                            showToolbar={true}
                                            disableRowSelectionOnClick={true}
                                            getRowId={(row: Reajuste) => row.idReajuste}
                                            columns={columnsDef}
                                            loading={viewModel.loading}
                                            checkboxSelection={false}
                                            rows={viewModel.reajusteLista}
                                            rowCount={viewModel.reajusteLista.length}
                                            pageSizeOptions={[10, 25, 50, 100]}
                                            paginationMode="server"
                                            paginationModel={{
                                                page: viewModel.pagination.page,
                                                pageSize: viewModel.pagination.rowsPerPage,
                                            }}
                                        />

                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                        />
                                    </Stack>
                                </div>
                            </>
                        )
                    }

                </div>

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            {
                                viewModel.selectedIdIndiceReajuste &&
                                <>
                                    <div>
                                        <PrimaryButton
                                            buttonColor="yellow"
                                            onClick={() => viewModel.handleOpenChangeHistory(viewModel.selectedIdIndiceReajuste ?? null, LogTipoTabela.INDICE_REAJUSTE)}>
                                            <span className="text-xs">
                                                Historico de alterações
                                            </span>
                                        </PrimaryButton>
                                    </div>
                                </>
                            }

                        </div>

                        <div className="w-full h-full flex justify-end items-center p-4 gap-6">
                            {
                                viewModel.selectedIdIndiceReajuste &&
                                <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                    <PrimaryButton
                                        startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                        onClick={() => viewModel.handleReajusteCadastroOpenState(true)}>
                                        Novo Reajuste
                                    </PrimaryButton>
                                </div>
                            }


                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        type="submit"
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form>

            <DeleteDialog
                open={viewModel.openDeleteModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleReajusteDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este arquivo?`}
                onDelete={viewModel.handleConfirmarDeletarReajuste}
            />

            <CadastroReajusteModal
                open={viewModel.openReajusteCadastroModal}
                saving={viewModel.saving}
                hookForm={viewModel.hookFormReajuste}
                selectedIdReajuste={viewModel.selectedIdReajuste}
                ddlContratosFinanceiro={viewModel.dropDownContratoFinanceiro ?? []}
                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onSubmit={viewModel.handleReajusteCadastroSubmit}
                onClose={() => viewModel.handleReajusteCadastroOpenState(false)}

            />

            <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
        </>
    )
}



